import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Container, Header } from 'semantic-ui-react'
import NavBar from '../components/NavBar'
import Requests from './Requests'
import { getUser } from '../redux/actions'

class Admin extends React.Component {

  componentDidMount() {
    const { user } = this.props
    if (_.isEmpty(user.data)) {
      //console.log("tenemos que traer la data del usuario")
      this.props.getUser()
    }
  }

  render() {
    //console.log("user: ", this.props.user)
    const { user } = this.props
    let isAdmin = _.has( user.data, 'isAdmin' ) ? true : false
    return (
      <div>
        <NavBar />
        <Container style={{marginTop: 150}}>
          <Header as='h1'>
            Administrator Panel
          </Header>
          <Header as='h2'>
            {'Hola ' + user.data.name}
          </Header>
            { 
              isAdmin 
                ? 
                  <Requests /> 
                : 
                  <p>You must be an administrator to access this resource</p>
            }
      
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { user } = state
  return { user }
}

export default connect(mapStateToProps, { getUser })(Admin)